import {
  Box,
  Heading,
  Container,
  Text,
  Button,
  Stack,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { Arrow } from "./arrow";

export const HeroComponent = () => {
  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Caveat:wght@700&display=swap"
        rel="stylesheet"
      />

      <Container maxW={"6xl"}>
        <Stack
          as={Box}
          textAlign={"center"}
          spacing={{ base: 8, md: 14 }}
          py={{ base: 20, md: 20 }}
        >
          <Heading
            fontWeight={600}
            fontSize={{ base: "xl", sm: "xl", md: "5xl" }}
            lineHeight={"110%"}
          >
            Designing and developing scalable, maintainable applications <br />
            with clean architecture, prioritizing simplicity <br />
            and purposeful design decisions{" "}
            <Text as={"span"} color={"green.400"}>
              for your specific needs
            </Text>
          </Heading>
          <Text color={"gray.500"}>
            Analyzing business requirements and implementing future-proof
            solutions that support both operational needs and sustainable
            growth.
          </Text>

          <Stack
            direction={"column"}
            spacing={3}
            align={"center"}
            alignSelf={"center"}
            position={"relative"}
          >
            <Button
              as={Link}
              to={"/contact"}
              colorScheme={"green"}
              bg={"green.400"}
              rounded={"full"}
              px={6}
              _hover={{
                bg: "green.500",
              }}
            >
              Contact me
            </Button>

            <Box>
              <Icon
                as={Arrow}
                color={useColorModeValue("gray.800", "gray.300")}
                w={71}
                position={"absolute"}
                right={-71}
                top={"10px"}
              />
              <Text
                fontSize={"lg"}
                fontFamily={"Caveat"}
                position={"absolute"}
                right={"-125px"}
                top={"-15px"}
                transform={"rotate(10deg)"}
              >
                Click me
              </Text>
            </Box>
          </Stack>
        </Stack>
      </Container>
    </>
  );
};
